<template>
  <ui-menu-base-trigger class="overflow-hidden" @focus="handleFocus">
    <template #default="{ openMenu }">
      <button
        ref="buttonRef"
        type="button"
        class="flex items-center overflow-hidden"
        :class="$attrs.class"
        :data-testid
        @click="openMenu"
        @keydown.enter="openMenu"
      >
        <span :class="textClassesByTheme[theme]" class="truncate">
          <slot />
        </span>
        <chevron-down-icon
          class="ml-1 flex shrink-0 duration-200 ease-out"
          :class="[iconSizeClasses[iconSize], iconClassesByTheme[theme], active && 'rotate-180 transform']"
        />
      </button>
    </template>
  </ui-menu-base-trigger>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import { ChevronDownIcon } from '../../../icons'

import { UiMenuSimpleTriggerTheme } from '../types'
import UiMenuBaseTrigger from './UiMenuBaseTrigger.vue'

withDefaults(
  defineProps<{
    active?: boolean
    theme?: UiMenuSimpleTriggerTheme
    iconSize?: 'sm' | 'md'
    dataTestid?: string
  }>(),
  {
    theme: UiMenuSimpleTriggerTheme.Default,
    iconSize: 'md',
    dataTestid: '',
  },
)

const buttonRef = ref<HTMLButtonElement | null>(null)

const handleFocus = () => {
  buttonRef.value?.focus()
}

const iconSizeClasses = {
  sm: 'icon-s',
  md: 'icon-m',
}

const textClassesByTheme = {
  [UiMenuSimpleTriggerTheme.Default]: 'text-gray-70 hover:text-gray-90',
  [UiMenuSimpleTriggerTheme.Light]: 'text-gray-60',
  [UiMenuSimpleTriggerTheme.Blue]: 'text-active-primary',
}

const iconClassesByTheme = {
  [UiMenuSimpleTriggerTheme.Default]: 'text-gray-70',
  [UiMenuSimpleTriggerTheme.Light]: 'text-gray-60',
  [UiMenuSimpleTriggerTheme.Blue]: 'text-active-primary',
}
</script>
